<script lang="ts" setup>
import Card3 from '@/components/Card/Card3.vue'
import Pagination2 from '@/components/Slider/Pagination2.vue'
import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore from 'swiper'
SwiperCore.use([Autoplay, Pagination])

import 'swiper/css'
import 'swiper/css/pagination'
import type { IEvent } from '@/utils/types/Event'

const props = defineProps({
  data: {
    type: Array as PropType<Array<IEvent>>,
    default: []
  }
})

const currentIndex: Ref<number> = ref(0)

// swiper
const swiperSlideSelector = ref()
const onSwiper = (data: any) => {
  //存放 swiper
  swiperSlideSelector.value = data
}

const swiperTo = (index: number) => {
  swiperSlideSelector.value.slideTo(index)
}

const handelSwiperChange = (data: any) => {
  currentIndex.value = data.realIndex
}

const handlePaginationChange = (index: number) => {
  swiperTo(index)
  currentIndex.value = index
}
</script>

<template>
  <section class="zonezoneBox4">
    <div class="zonezoneBox4__top" data-aos="fade-up" data-aos-duration="1500">
      <div class="zonezoneBox4__top__enTitle">events opening</div>
      <div class="zonezoneBox4__top__twTitle">報名中的活動</div>
    </div>
    <swiper :autoplay="{
      delay: 3000
    }" :slides-per-view="1" :space-between="24" :speed="300" :loop="true" :breakpoints="{
  991: {
    slidesPerView: 2
  }
}" class="zonezoneBox4__swiper" @swiper="onSwiper" @slide-change="handelSwiperChange">
      <swiper-slide v-for="item in data" :key="item.id">
        <Card3 :item="item" />
      </swiper-slide>
    </swiper>
    <div class="zonezoneBox4__pagination">
      <Pagination2 :currentIndex="currentIndex" @update:change="handlePaginationChange" :totalIndex="5"
        class="pagination-box__item" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.zonezoneBox4 {
  margin-bottom: toRem(180);

  @include max-media(990) {
    margin-bottom: toRem(100);
  }

  &__top {
    position: relative;
    z-index: 1;
    color: $color-white-1;
    margin-bottom: toRem(50);

    @include max-media(990) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: toRem(12);
    }

    &__enTitle {
      line-height: 80%;
      font-family: $font-TextaAlt;
      // font-size: toRem(80);
      font-size: 5.5vw;
      font-weight: 500;
      letter-spacing: toRem(-1.6);

      @include max-media(990) {
        font-size: toRem(80);
      }
    }

    &__twTitle {
      line-height: 1;
      // font-size: toRem(28);
      font-size: 2vw;
      font-weight: 500;

      @include max-media(990) {
        font-size: toRem(28);
      }
    }
  }

  &__pagination {
    width: 100%;
    max-width: toRem(330);
    margin-top: toRem(20);
  }
}
</style>
<style lang="scss">
.zonezoneBox4 {
  &__swiper {
    .swiper-pagination {
      position: relative;
      bottom: 0;
      top: 0;
      text-align: left;
      padding-top: toRem(10);
    }
  }
}
</style>
